var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkout-promo" }, [
    _c("h4", [_vm._v("Промокод")]),
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.apply($event)
          }
        }
      },
      [
        _c("ui-input", {
          attrs: { readonly: !!_vm.cartCode, placeholder: "Введите промокод" },
          model: {
            value: _vm.inputCode,
            callback: function($$v) {
              _vm.inputCode = $$v
            },
            expression: "inputCode"
          }
        }),
        _c("ui-button", {
          attrs: {
            type: "submit",
            text: _vm.cartCode ? "Удалить" : "Применить",
            secondary: !!_vm.cartCode,
            disabled: !_vm.cartCode && !_vm.code,
            loading: _vm.loading
          }
        })
      ],
      1
    ),
    _vm.cartCode
      ? _c("p", { domProps: { textContent: _vm._s(_vm.discountText) } })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }